export const sizeInMegaBytes = (bytes) => {
  if (!bytes) {
    0;
  }

  return (bytes / Math.pow(1024, 2)).toFixed(2);
};

export const sizeInBytes = (megabytes) => {
  if (!megabytes) {
    0;
  }

  return megabytes * Math.pow(1024, 2);
};